import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { convertStraight } from "../common-data/Converts";
import {
  BinIcon,
  CheckCircleIcon,
  EditIcon,
  XCircleIcon,
} from "../../images/icons/icons";
import TableSkeleton from "../common-components/TableSkeleton";
import { commonDeleteApi } from "../../redux/reducers/deleteApiSlice";

const GymAliasTable = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  userInfoData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { gymAlias, gymAliasLoading } = useSelector((state) => state?.webApi);

  const handleEdit = (rowData) => {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      modName: "edit",
      rowData: rowData,
    }));
  };

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: "/gym/alias",
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  const tableColumns = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => (
        <span className="tb-data minWidth150">{row?.gym_name || "N/A"}</span>
      ),
    },
    {
      dataField: "alias_name",
      text: "Alias Name",
      formatter: (_, row) => (
        <span className="tb-data minWidth150">
          {row?.alias?.replace(/_/g, " ") || "N/A"}
        </span>
      ),
    },
    {
      dataField: "is_pt",
      text: "PT",
      formatter: (_, row) => (
        <span className="tb-data icon">
          {row?.is_pt ? <CheckCircleIcon /> : <XCircleIcon />}
        </span>
      ),
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => (
        <span
          className={`tb-data status-badge ${
            row?.status === "active" ? "active" : "inactive"
          }`}
          style={{ border: "none", color: "#fff" }}
        >
          {row?.status === "active" ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => (
        <span className="tb-data minWidth120">
          {row?.date_added ? convertStraight(row.date_added) : "-"}
        </span>
      ),
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            type="button"
            className="actionBtn icon edit"
            onClick={() => handleEdit(row)}
            title="Edit"
          >
            <EditIcon />
          </button>
          <button
            type="button"
            className="actionBtn icon delete"
            onClick={() => {
              const payload = {
                uid: row?.uid || "",
              };

              handleDelete(payload);
            }}
            title="Delete"
          >
            <BinIcon />
          </button>
        </div>
      ),
    },
  ];

  if (gymAliasLoading) {
    return <TableSkeleton />;
  }

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable mt15 ">
      <PaymentLinkTable
        tableData={gymAlias?.data || []}
        tableColumns={tableColumns}
        tablePagination={gymAlias?.pagination}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
      />
    </div>
  );
};

export default GymAliasTable;
